import ClientBindVehicleInfoGroupModal from './client-bind-vehicle-info-group-modal.vue'
export default ClientBindVehicleInfoGroupModal
